<template>
  <div class="loading">
    <h1>Welcome to IFA prototype</h1>
    <button class="green" :disabled="!isLoadingComplete" @click="$emit('update_gain', gain_delta); $emit('next')">
      next
    </button>
    <h3>Loaded {{ loaded_audio }} / {{ total_audio }} AUDIO resources</h3>
    <h3>Loaded {{ loaded_video }} / {{ total_video }} VIDEO resources</h3>

    <!-- <div class="slidecontainer"> -->
      <br>
      <br>
      <input type="range" min="0" max="6" v-model="gain_delta">
      <h3>ON / OFF delta = {{ gain_delta }} dB</h3>
      <br>
      <br>
      If this is not being served over HTTPS ^ (look up)
      It will NOT have installed properly as an app on iOS!!

    <!-- </div> -->
  </div>
</template>

<script>
export default {
  name: 'Loading',
  emits: [
    "next",
    "update_gain"
  ],
  props: [
    "total_audio",
    "loaded_audio",
    "total_video",
    "loaded_video",
  ],
  data() {
    return {
      gain_delta: 0
    }    
  },
  computed: {
    isLoadingComplete() {
      return this.total_audio + this.total_video == this.loaded_audio + this.loaded_video;
    }
  },
}
</script>

<style>
div.loading {
  padding-left: 20px;
}
</style>